import DashboardTopBarContentView from './DashboardTopBarContentView';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useChatState } from '@core/chat/context';
import { IDashboardTopBarContent } from './interfaces';
import { useConference } from '../../DashboardContent/Dolby';
import { useMytaverse } from '@providers/MytaverseProvider';
import ParticipantScopes from '@constants/scopes';

const DashboardTopBarContent = ({
  onOpenInviteUserModal,
}: IDashboardTopBarContent) => {
  const { participants, currentRoom, currentEvent } = useMytaverseEvent();
  const { screenMediaStreams } = useConference();
  const { open: isOpenChat } = useChatState();
  const { userPermissions } = useMytaverse();

  const showInviteUserBtn =
    userPermissions?.includes(ParticipantScopes.HubInviteParticipants) ?? false;
  const participantTotal = participants.filter(({ roomId }) => roomId).length;
  const hasMediaStream = !!screenMediaStreams?.length;

  return (
    <DashboardTopBarContentView
      currentRoom={currentRoom}
      isOpenChat={isOpenChat}
      hasMediaStream={hasMediaStream}
      showInviteUserBtn={showInviteUserBtn}
      participantTotal={participantTotal}
      onOpenInviteUserModal={onOpenInviteUserModal}
      currentEvent={currentEvent}
    />
  );
};

export default DashboardTopBarContent;
